const POSTS = [
  { no: 1, cat: '人物深扒', title: '他从"行业导师"到"删号跑路"：人设崩塌的每一步都有原帖', lead: '晒单、讲座报名记录、私人号小号被顺藤摸瓜，时间线从去年十月一路排到昨天。', meta: '图文详解 28 图', views: '6.8k' },
  { no: 2, cat: '图文深扒', title: '一份被删除的合作协议，红线圈出三处"文字游戏"', lead: '原协议已在转存帖补档，逐条标注与谈判时口头承诺的出入。', meta: '已补原图', views: '4.4k' },
  { no: 3, cat: '实锤复盘', title: '生日直播"念错品牌名"背后：是口误还是撤投前兆', lead: '翻出前后三天该品牌直播频次、投流截图，把"口误"拆开看。', meta: '数据对照', views: '9.1k' },
  { no: 4, cat: '图文深扒', title: '招聘帖里一句"弹性下班"，评论区晒出 22 份打卡记录', lead: '员工晒出的下班时间统计异常整齐，楼主正逐份比对真实性。', meta: '持续核验', views: '2.2k' },
  { no: 5, cat: '细节深扒', title: '道歉声明里三个"我"，分别藏了什么潜台词', lead: '从用词密度看态度变化，把近一年同类声明拉出来横向比。', meta: '图解 5 图', views: '5.6k' }
];

const DIAGRAM_PICKS = [
  { title: '两版声明逐字比对', stat: '差 14 处 · 8 图' },
  { title: '直播后台数据轴', stat: '跨 90 天 · 12 图' },
  { title: '评论风向往复折线', stat: '3 波 · 6 图' }
];

export default function DeepRead() {
  return (
    <section id="deep-read" className="bg-paper">
      <div className="mx-auto max-w-[1360px] px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-3 border-b-2 border-ink pb-3">
          <div>
            <div className="flex items-center gap-2">
              <i className="ri-article-line text-xl text-verm" />
              <h2 className="font-display text-xl font-black md:text-2xl">图文深扒 · 最新</h2>
            </div>
            <p className="mt-1 text-sm text-ink/55">标题说一半，剩下都在帖子里。每篇都是完整帖子内容，不让你划走。</p>
          </div>
          <div className="flex items-center gap-1 rounded-full border border-line bg-paper2 p-1">
            {['全部', '人物', '品牌', '事件', '平台'].map((t, i) => (
              <button
                key={t}
                type="button"
                className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm font-medium ${
                  i === 0 ? 'bg-verm text-paper2' : 'text-ink/60 hover:text-verm'
                }`}
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        <div className="grid gap-8 lg:grid-cols-3">
          {/* 标题优先的深扒列表 */}
          <div className="lg:col-span-2">
            <div className="divide-y divide-line/70 border border-line bg-paper2">
              {POSTS.map((p) => (
                <article key={p.no} className="group flex gap-4 p-4 transition-colors hover:bg-verm-wash md:gap-5 md:p-5">
                  <span className="font-display hidden text-2xl font-black leading-none text-band group-hover:text-verm/30 md:block">
                    {String(p.no).padStart(2, '0')}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="bg-band px-1.5 py-0.5 text-[11px] font-semibold tracking-widest text-verm">{p.cat}</span>
                      <span className="flex items-center gap-1 text-xs text-ink/45"><i className="ri-eye-line" /> {p.views}</span>
                    </div>
                    <h3 className="mt-2 text-base font-bold leading-snug group-hover:text-verm md:text-lg">
                      <a href="#deep-read" className="hover:text-verm">{p.title}</a>
                    </h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-ink/60">{p.lead}</p>
                    <div className="mt-3 flex flex-wrap items-center justify-between gap-2 text-xs text-ink/50">
                      <span className="flex items-center gap-3">
                        <span className="flex items-center gap-1"><i className="ri-image-2-line" /> {p.meta}</span>
                        <span className="hidden items-center gap-1 sm:flex"><i className="ri-time-line" /> 09-0{p.no}</span>
                      </span>
                      <a href="#deep-read" className="flex items-center gap-1 whitespace-nowrap font-semibold text-verm hover:opacity-75">
                        进帖子看全文 <i className="ri-arrow-right-line" />
                      </a>
                    </div>
                  </div>
                </article>
              ))}
            </div>
            <a
              href="#deep-read"
              className="mt-4 flex items-center justify-center gap-1 border border-line bg-paper2 py-3 text-sm font-semibold text-ink/65 hover:border-verm hover:text-verm"
            >
              <i className="ri-loader-3-line" /> 加载更多图文深扒
            </a>
          </div>

          {/* 右栏：图解细节入口 + 今日素材包 */}
          <aside className="space-y-6">
            <div className="border-l-4 border-verm bg-band p-4 md:p-5">
              <div className="flex items-center gap-2">
                <i className="ri-focus-3-line text-lg text-verm" />
                <h3 className="font-display text-base font-black">图解细节 · 配套</h3>
              </div>
              <p className="mt-1.5 text-xs leading-relaxed text-ink/60">不想啃长文的，直接看图解对照看重点。</p>
              <div className="mt-3 space-y-2">
                {DIAGRAM_PICKS.map((d) => (
                  <a
                    href="#diagram"
                    key={d.title}
                    className="flex items-center justify-between rounded-md border border-line bg-paper2 px-3 py-2.5 text-sm hover:border-verm/50"
                  >
                    <span className="font-medium group-hover:text-verm">{d.title}</span>
                    <span className="ml-2 flex shrink-0 items-center gap-1 text-[11px] text-gold">
                      <i className="ri-image-line" /> {d.stat}
                    </span>
                  </a>
                ))}
              </div>
            </div>

            <div className="border border-line bg-paper2 p-4 md:p-5">
              <h3 className="flex items-center gap-2 font-display text-base font-black">
                <i className="ri-price-tag-3-line text-verm" /> 本周热词索引
              </h3>
              <div className="mt-3 flex flex-wrap gap-2">
                {['停更回归', '口误撤投', '删帖补档', '代运营自评', '合伙人分账', '前员工站队', '声明改口'].map((t, i) => (
                  <a
                    key={t}
                    href="#collections"
                    className="rounded-full border border-line bg-band px-2.5 py-1 text-xs hover:border-verm hover:bg-verm-soft"
                  >
                    <span className="mr-1 text-[10px] text-ink/40">#{i + 1}</span>
                    {t}
                  </a>
                ))}
              </div>
              <p className="mt-3 border-t border-dashed border-line pt-3 text-[11px] leading-relaxed text-ink/45">
                素材均为公开网络讨论整理，点词直达对应合集索引，配图解与长文同步收录。
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}